import Swiper from 'swiper';
import { Navigation, Pagination, Zoom } from 'swiper/modules';

$(document).ready(() => {
    $('.swiper').each((index, element) => {
        new Swiper(element, {
            autoHeight: true,
            spaceBetween: 100,
            zoom: true,
            loop: true,
            modules: [Pagination, Navigation, Zoom],

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: $(element).find('.swiper-button-next').get(0),
                prevEl: $(element).find('.swiper-button-prev').get(0),
            },
        });
    })

})
